import React from "react";
import "./Button.css";
import classnames from "classnames";
import PropTypes from "prop-types";

const Button = ({
  className,
  onClick,
  label,
  type,
  disabled,
  style,
  indicatorButton,
  formType,
}) => {
  return (
    <button
      type={formType}
      className={classnames(
        "btn mt-2 mb-2 shadow-none",
        `btn-${type}`,
        className
      )}
      style={{
        ...style,
        width: indicatorButton && 80,
        height: indicatorButton && 50,
        borderColor: indicatorButton && "#828282",
        borderRadius: indicatorButton && 50,
        textDecoration: "none",
      }}
      disabled={disabled}
      onClick={onClick}
    >
      {label}
    </button>
  );
};

Button.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  onClick: PropTypes.func.isRequired,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  type: PropTypes.string,
};

Button.defaultProps = {
  className: undefined,
  type: "info",
};

export default Button;
